export enum SelectUrlSegment {
    Select = 'select',
}
